import * as React from 'react'
import {GlobalStoresContext} from "../contexts/global_stores_context";

export const useGlobalStores = () => React.useContext(GlobalStoresContext);
